<div class="flex flex-col items-center">
  <app-divider />
  <div class="mt-6 mb-14 flex flex-col items-center text-center max-w-3xl">
    @if (header(); as header) {
      <h2 [ngClass]="{ 'text-white': isLight() }" class="text-4xl text-primary">
        {{ header }}
      </h2>
    }
    <p
      [ngClass]="{ 'text-white': isLight() }"
      class="text-2xl text-slate-700 font-light"
    >
      {{ description() }}
    </p>
    @if (sub(); as sub) {
      <p
        [ngClass]="{ 'text-white': isLight() }"
        class="text-md text-slate-700 font-light"
      >
        {{ sub }}
      </p>
    }
  </div>
</div>
